import { useEventContext } from 'context/EventContext';
import { useRouter } from 'next/router';
import { useInfiniteQuery } from 'react-query';
import { getEventList, GetEventListQueryParmas } from './eventApi';
import { queryKeys } from './queryClient';

export const useEventList = () => {
  const { locale } = useRouter();
  const {
    state: { currPageNum, pageSize, type, search, status },
  } = useEventContext();

  // type -> all 일 경우 undefined, status -> all 일 경우 undefined, search -> 공백 검사
  const reqParams: GetEventListQueryParmas = {
    language: locale === 'en' ? 'eng' : 'kor',
    page_size: +pageSize,
    page_num: +currPageNum,
    type: type === 'all' ? undefined : type,
    status: status === 'all' ? undefined : status,
    keyword: !search ? undefined : search,
  };

  const query = useInfiniteQuery(
    [queryKeys.eventList, currPageNum, pageSize, type, search, status, locale],
    ({ pageParam = reqParams }) => {
      return getEventList(pageParam);
    },
    {
      getNextPageParam: lastPage => {
        const totalPageNum = Math.ceil(
          (+lastPage?.all_count || 0) / (+lastPage?.page_size || 1)
        );
        const currentPageNum = +lastPage?.page_num || 0;
        return totalPageNum - 1 >= +currentPageNum + 1
          ? { ...reqParams, page_num: +currentPageNum + 1 }
          : undefined;
      },
    }
  );

  return query;
};
